import { ReportViewerModal } from "../../../../common/components/report_viewer_modal";
import { ReportChecklistModal } from "./report_checklist_modal";
import { ReportMapaConcretagemModal } from "./report_mapa_concretagem_modal";
import { ReportMonitoramentoChecklistModal } from "./report_monitoramento_checklist_modal";
import { ObrasCommonReportsState } from "./hooks/obras_common_reports";
import { ReportJobWaiterModal } from "./report_job_waiter_modal";

/**
 * ObrasReportModals
 */

type Props = {
  state: ObrasCommonReportsState;
};

export const ObrasReportModals = ({
  state,
}: Props) => {
  return (
    <>
      <ReportMapaConcretagemModal
        open={state.openReportMapaConcretagemModal}
        loading={state.loading}
        saving={state.saving}
        filtros={state.filtroMapaConcretagem ?? null}
        fornecedores={state.fornecedoresDropDown}
        onClose={state.handleReportMapaConcretagemModalOpenState}
        onSubmit={state.handleReportMapaConcretagemSubmit}
        onSubmitColumns={state.handleReportMapaConcretagemSubmitColumns}
      />

      <ReportMonitoramentoChecklistModal
        open={state.openReportMonitoramentoChecklistModal}
        loading={state.loading}
        saving={state.saving}
        obraAreasDropDown={state.obraAreasDropDown}
        obraServicosDropDown={state.obraServicosDropDown}
        monitoramentoChecklistEmpresas={state.monitoramentoChecklistEmpresasDropDown}
        monitoramentoChecklistFuncionarios={state.monitoramentoChecklistFuncionariosDropDown}
        onClose={state.handleReportMonitoramentoChecklistModalOpenState}
        onSubmit={state.handleReportMonitoramentoChecklistSubmit}
      />

      <ReportChecklistModal
        open={state.openReportChecklistModal}
        loading={state.loading}
        saving={state.saving}
        obraAreasDropDown={state.obraAreasDropDown}
        obraServicosDropDown={state.obraServicosDropDown}
        onClose={state.handleReportChecklistModalOpenState}
        onSubmit={form => {
          const areaName = state.obraAreasDropDown?.find(x => x.idObraAreaChecklist === form.area)?.descricao;
          state.handleReportChecklistSubmit(form, areaName ?? null);
        }}
      />

      <ReportJobWaiterModal
        open={state.openReportJobWaiterModal}
        result={state.reportJobResult}
        onClose={() => state.handleCloseReportJobWaiterModal()}
      />

      <ReportViewerModal
        reportViewerState={state.reportViewerState}
      />

    </>
  );
}
